import { render, staticRenderFns } from "./RoomInfoIcon.vue?vue&type=template&id=3f12e91c&"
import script from "./RoomInfoIcon.vue?vue&type=script&lang=js&"
export * from "./RoomInfoIcon.vue?vue&type=script&lang=js&"
import style0 from "./RoomInfoIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f12e91c')) {
      api.createRecord('3f12e91c', component.options)
    } else {
      api.reload('3f12e91c', component.options)
    }
    module.hot.accept("./RoomInfoIcon.vue?vue&type=template&id=3f12e91c&", function () {
      api.rerender('3f12e91c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RoomInfoIcon.vue"
export default component.exports